<template>
  <public-calendar :time-views="timeViews" :default-mobile-view="defaultMobileView" :event-render-callback="eventRender" :base-event-show-url="baseEventShowUrl">
    <template v-slot:spinner>
      <spinner :addtl-class="spinnerColor" top="7px" left="120px;"></spinner>
    </template>
  </public-calendar>
</template>
<script>
import PublicCalendar from '../sharedteamwebsite/public_calendar.vue';
import Spinner from './icons/spinner.vue';
import { calendarHelpers } from '../sharedteamwebsite/mixins/calendar_helpers';

export default {
  name: 'tailwind-calendar',
  components: { Spinner, PublicCalendar },
  mixins: [calendarHelpers],
  props: {
    spinnerColor: {
      type: String,
      default: "text-dam-orange",
    },
    timeViews: {
      type: String,
      default: 'dayGridMonth,timeGridWeek,listWeek,multiMonthYear',
    },
    defaultMobileView: {
      type: String,
      default: 'listWeek',
    },
    baseEventShowUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    eventRender(eventObj, $el) {},
  },
};
</script>
